const _require = require('../lib/getFormContent'),
  traverseFormContent = _require.traverseFormContent;

/**
  * @function evaluate - evaluate readReferencedContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const _await$traverseFormCo = await traverseFormContent(source, content, parentContentPath, transientContext, nativeFunctions),
    value = _await$traverseFormCo.value;
  return value;
};
module.exports = {
  evaluate
};